module.exports = __webpack_public_path__ + "media/images/miteina-logo-17bfa24d00c5cefee118ac5a85d674d9.png";